import Icon, {iconTypes} from "../../../common/components/Icon.jsx";

import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import {withRouter} from "react-router-dom";

class DashboardHelpSupport extends React.Component {
    constructor(props){
        super(props);
        this.onClickMessageUs = this.onClickMessageUs.bind(this);
        this.onClickFaq = this.onClickFaq.bind(this);
    }
    onClickMessageUs() {
        this.props.history.push("/help/faq/");
    }
    onClickFaq() {
        this.props.history.push("/help/faq/");
    }
    render(){
        const {
            localization
        } = this.props;
        return (
            <div className="card-default">
                <div className="dashboard-myproductlist-body">
                    <div className="dashboard-card-header">
                        {localization.text("dashboard","help&support")}
                    </div>
                    <br />
                    <div className="dashboard-myproductlist-body-text">
                        {localization.text("dashboard","anyQuestions")}
                    </div>
                </div>
                <div className="hr"/>
                <div className="dashboard-card-bottom">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn icon block"} onClick={this.onClickMessageUs} disabled={false}>
                                <Icon type={iconTypes.chatBubble}/>
                                {localization.text("dashboard","messageUs")}
                            </button>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} lg={6}>
                            <button className={"btn block"} onClick={this.onClickFaq} disabled={false}>
                                {localization.text("dashboard","browseFaq")}
                            </button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </div>
        );
    }
}
DashboardHelpSupport.propTypes = {
    localization: Localization.propTypes.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(DashboardHelpSupport);